import apiClient from './api';

export const cargaMasivaService = {
  // Obtener resumen del personal actual
  getResumenPersonal: async () => {
    try {
      const response = await apiClient.get('/bulk/resumen-personal');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.detail || 'Error al obtener resumen del personal');
    }
  },

  // Descargar plantilla CSV
  descargarPlantilla: async () => {
    try {
      const response = await apiClient.get('/bulk/plantilla-personal', {
        responseType: 'blob'
      });
      
      // Crear URL para descarga
      const blob = new Blob([response.data], { 
        type: 'text/csv; charset=utf-8' 
      });
      const url = window.URL.createObjectURL(blob);
      
      // Crear elemento de descarga
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `plantilla_personal_${new Date().toISOString().split('T')[0]}.csv`;
      
      // Ejecutar descarga
      document.body.appendChild(a);
      a.click();
      
      // Limpiar
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      return { success: true };
    } catch (error) {
      throw new Error(error.response?.data?.detail || 'Error descargando plantilla');
    }
  },

  // Cargar archivo CSV masivo
  cargarPersonalMasivo: async (archivo) => {
    try {
      const formData = new FormData();
      formData.append('archivo', archivo);

      const response = await apiClient.post('/bulk/cargar-personal-masivo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.detail || 'Error procesando archivo');
    }
  }
};

export default cargaMasivaService;
